/**
 * Just Read — reader-mode / distraction-free reading
 *
 * A single WAR entry exposes its stylesheets and options assets — `required-styles.css`,
 * `default-styles.css`, `dark-styles.css`, `page.css`, `options.js`, `options.css` and
 * `fonts/*` — to every origin with no `use_dynamic_url`, so each is fetchable from any
 * page at a fixed URL.
 *
 * There are no images in the WAR group, so the primary signal fetches the most
 * distinctive stylesheet. Serving any of these confirms the extension is installed.
 *
 * Manifest verified against version 6.1.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'dgmanlpmmkibanfdgjocnabmcaclkmod';

export const justRead: ExtensionDefinition = {
  id: ID,
  name: 'Just Read',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 200_000,
  notes:
    'Exposes its reader stylesheets and options assets to every origin with no dynamic ' +
    'URL. Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-required-styles-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch required-styles.css — the reader-mode base stylesheet exposed to every ' +
        'origin at a fixed path.',
      weight: 1,
      run: () => probeFetch(ID, 'required-styles.css'),
    },
    {
      id: 'war-default-styles-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch default-styles.css — the default theme stylesheet, corroborating the ' +
        'identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'default-styles.css'),
    },
    {
      id: 'war-page-css',
      kind: 'web-accessible-resource',
      description: 'Fetch page.css — a third independent stylesheet path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'page.css'),
    },
  ],
};
